'use strict';

/**
 * Add query params to a url
 * @param obj: object of queries to be added in url
 * @param prefix: prefix key to added before every query key
 * @returns string of query param
 */
var queryParamsStringify = function (obj, prefix) {
    if (prefix === void 0) { prefix = ""; }
    return Object.keys(obj)
        .map(function (key) {
        var value = obj[key];
        var prefixedKey = prefix
            ? "".concat(prefix, "[").concat(encodeURIComponent(key), "]")
            : encodeURIComponent(key);
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "object" && !Array.isArray(value)) {
            return queryParamsStringify(value, prefixedKey); // Recursively handle nested objects.
        }
        if (Array.isArray(value)) {
            return value
                .map(function (v) { return "".concat(prefixedKey, "[]=").concat(encodeURIComponent(v)); })
                .join("&"); // Handle arrays.
        }
        return "".concat(prefixedKey, "=").concat(encodeURIComponent(value));
    })
        .filter(function (pair) { return pair.length > 0; }) // Remove empty strings for null/undefined.
        .join("&");
};

exports.queryParamsStringify = queryParamsStringify;
//# sourceMappingURL=APi.utils.js.map
